<div *ngIf="requestState">
    <div class="chart-container" #chartTarget style="width: 100%"></div>
</div>
